module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-4.2cc65b9b.png";